var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"dark":"","block":_vm.block,"outlined":_vm.outlined},on:{"click":_vm.logoutClicked}},[_c('v-icon',{attrs:{"dense":"","left":""}},[_vm._v("mdi-logout")]),_vm._v(" Logout ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }